import React from "react";
import { Plus, PanelRightOpen, PanelRightClose } from "lucide-react";

interface HeaderProps {
  appName: string;
  appType?: string;
  userName?: string | null;
  onNewChat?: () => void;
  onSidebarToggle?: () => void;
  onSessionsClick?: () => void;
  onSettingsClick?: () => void;
  showingSidebar?: boolean;
}

export function Header({
  appName,
  userName,
  onNewChat,
  onSidebarToggle,
  onSessionsClick,
  onSettingsClick,
  showingSidebar,
}: HeaderProps) {
  const initials = userName
    ? userName
        .split(" ")
        .map((n) => n[0])
        .join("")
        .slice(0, 2)
        .toUpperCase()
    : null;

  const handleSidebar = onSidebarToggle ?? onSessionsClick ?? onSettingsClick;

  return (
    <div className="px-4 py-3 flex items-center justify-between shrink-0 cai-glass relative z-10">
      <div className="flex items-center gap-2.5">
        <div className="w-7 h-7 cai-avatar rounded-lg shrink-0 flex items-center justify-center">
          <span className="text-[9px] font-bold text-white tracking-tight leading-none">CAi</span>
        </div>
        <span className="font-semibold text-[15px] text-text-primary tracking-tight">
          {appName}
        </span>
      </div>
      <div className="flex items-center gap-1">
        {onNewChat && (
          <button
            onClick={onNewChat}
            className="w-8 h-8 rounded-lg flex items-center justify-center text-text-secondary hover:text-accent-violet hover:bg-accent-violet/10 transition-all"
            title="New chat"
          >
            <Plus size={16} strokeWidth={2.5} />
          </button>
        )}
        {handleSidebar && (
          <button
            onClick={handleSidebar}
            className={`w-8 h-8 rounded-lg flex items-center justify-center transition-all ${
              showingSidebar
                ? "bg-accent-violet/15 text-accent-violet"
                : "text-text-secondary hover:text-accent-violet hover:bg-accent-violet/10"
            }`}
            title={showingSidebar ? "Close panel" : "History & Settings"}
          >
            {showingSidebar ? (
              <PanelRightClose size={16} strokeWidth={2} />
            ) : (
              <PanelRightOpen size={16} strokeWidth={2} />
            )}
          </button>
        )}
        {initials && (
          <div className="w-7 h-7 bg-accent-violet/20 text-accent-violet rounded-full flex items-center justify-center text-[10px] font-bold ml-0.5">
            {initials}
          </div>
        )}
      </div>
    </div>
  );
}
